import { InvoicesI } from '../interfaces/invoices.interface'
import { InvoicesService } from '../services/invoices.service'
import {
    CompleteDataWithServicesPayloadT,
    InvoicesDownloadExcelPayloadT,
    InvoicesDownloadExcelResponseT,
    InvoicesGetListParamsT,
    InvoicesGetListResponseT,
    InvoicesGetListShortParamsT,
    InvoicesGetQuantityParamsT,
    InvoicesGetQuantityResponseT,
    InvoicesGetStatusesResponse,
    InvoicesInternationalGetListParamsT,
    InvoicesWithServicesDownloadExcelPayloadT,
    InvoicesWithServicesDownloadExcelResponseT,
    InvoicesWithServicesListResponseT,
    UpdateInvoicePayloadT,
    UplodaFilesResponseT,
    WithServicesListParamsT,
} from '../types/invoices.types'

const invoicesService = new InvoicesService()

class InvoicesRealisation implements InvoicesI {
    getList(
        params: InvoicesGetListParamsT | InvoicesGetListShortParamsT
    ): Promise<InvoicesGetListResponseT> {
        return invoicesService.getList(params)
    }

    getInvoiceStatuses(): Promise<InvoicesGetStatusesResponse> {
        return invoicesService.getInvoiceStatuses()
    }

    getListInternational(
        params: InvoicesInternationalGetListParamsT
    ): Promise<InvoicesGetListResponseT> {
        return invoicesService.getListInternational(params)
    }

    getQuantity(params: InvoicesGetQuantityParamsT): Promise<InvoicesGetQuantityResponseT> {
        return invoicesService.getQuantity(params)
    }

    updateInvoice(invoice_id: number, payload: UpdateInvoicePayloadT): Promise<void> {
        return invoicesService.updateInvoice(invoice_id, payload)
    }

    importCashSum(form_data: FormData): Promise<void> {
        return invoicesService.importCashSum(form_data)
    }

    importInvoices(form_data: FormData): Promise<void> {
        return invoicesService.importInvoices(form_data)
    }

    importDeleteAdditional(form_data: FormData): Promise<void> {
        return invoicesService.importDeleteAdditional(form_data)
    }

    importDeclaredPrice(form_data: FormData): Promise<void> {
        return invoicesService.importDeclaredPrice(form_data)
    }

    withServicesList(params: WithServicesListParamsT): Promise<InvoicesWithServicesListResponseT> {
        return invoicesService.withServicesList(params)
    }

    enterDataWithServices(
        invoice_id: number,
        additionalServices: CompleteDataWithServicesPayloadT[]
    ): Promise<void> {
        return invoicesService.enterDataWithServices(invoice_id, additionalServices)
    }

    exportExcel(params: InvoicesDownloadExcelPayloadT): Promise<InvoicesDownloadExcelResponseT> {
        return invoicesService.exportExcel(params)
    }

    exportKaspiReport(
        params: InvoicesDownloadExcelPayloadT
    ): Promise<InvoicesDownloadExcelResponseT> {
        return invoicesService.exportKaspiReport(params)
    }

    exportExcelWithServices(
        params: InvoicesWithServicesDownloadExcelPayloadT
    ): Promise<InvoicesWithServicesDownloadExcelResponseT> {
        return invoicesService.exportExcelWithServices(params)
    }

    deleteService(id: number): Promise<void> {
        return invoicesService.deleteService(id)
    }

    deleteFile(id: number): Promise<void> {
        return invoicesService.deleteFile(id)
    }

    deleteStatus(id: number): Promise<void> {
        return invoicesService.deleteStatus(id)
    }

    uploadFiles(form_data: FormData): Promise<UplodaFilesResponseT> {
        return invoicesService.uploadFiles(form_data)
    }
}

export const invoices = new InvoicesRealisation()
